import { render, staticRenderFns } from "./StandaloneOnboardingSlide.vue?vue&type=template&id=1520bcea&scoped=true"
import script from "./StandaloneOnboardingSlide.vue?vue&type=script&lang=ts"
export * from "./StandaloneOnboardingSlide.vue?vue&type=script&lang=ts"
import style0 from "./StandaloneOnboardingSlide.vue?vue&type=style&index=0&id=1520bcea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520bcea",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QBtn,QCarousel});qInstall(component, 'directives', {ClosePopup});
